import Image from 'next/image';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';

const GridItem = ({ item }) => {
  const { recipeMetaSection, _meta, assets } = item || {};
  const { deliveryKey } = _meta || {};
  const imgUrl =
    assets?.length > 0 ? buildImageSrc(assets[0], 400, 4, 3) : buildImageSrc(null, 400, 4, 3);
  const linkObj = buildLinkObj({ link: deliveryKey });

  return (
    <div className="tw-bg-white tw-h-full tw-p-2 sm:tw-p-8">
      <a href={linkObj.href} className="tw-flex tw-flex-col tw-h-full">
        <div className="tw-relative tw-w-full tw-aspect-[4/3]">
          <Image
            src={imgUrl}
            alt=''
            fill
            className="tw-object-cover"
            priority={false}
          />
        </div>
        <h6 className="tra-text-web-heading-6 tw-mt-3 tw-text-left">{recipeMetaSection?.title}</h6>
      </a>
    </div>
  );
};

export default GridItem;
